var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.runDocumentsLoaded)?_c('Manual'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }